import React, {FC} from "react"

import TreatsTriggerModal from "@irati-web/wallet/src/components/TreatsModal/TreatsTriggerModal"
import {FormattedMessage} from "@irati/utils/lang"
import {H3} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"

interface RenderLaneProps {
  bodyText: string
}

const FPDealsSectionHeader: FC<RenderLaneProps> = ({bodyText}) => (
  <Flex alignItems="center" margin={[4, 0]}>
    <H3 marginRight={1}>
      <FormattedMessage id="perks.brand.brandPage.lane.fpDeals.title" values={{count: bodyText}} />
    </H3>
    <TreatsTriggerModal />
  </Flex>
)

export default FPDealsSectionHeader
